import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import { RiskAssessmentResultControlType as Risk_Assessment_Result_Control_Type_Enum } from '@risksmart-app/domain/src/types/consts/risk-assessment-result-control-type';
import type { useGetOversightResultsByParentId } from 'src/hooks/queries/assessment-result/useGetOversightResultsByParentId';

import type { OversightResultFields } from './types';

type GetOversightResultsByParentIdData = NonNullable<
  ReturnType<typeof useGetOversightResultsByParentId>['data']
>;

export const getOversightResultTableFields = (
  data: GetOversightResultsByParentIdData | undefined,
  assessmentId: string
): OversightResultFields[] | undefined => {
  return [
    ...(data?.document_oversight_result.map((a) => ({
      ...a,
      ParentId: assessmentId,
      ResultType: Parent_Type_Enum.DocumentOversightResult,
    })) || []),
    ...(data?.obligation_oversight_result.map((a) => ({
      ...a,
      ParentId: assessmentId,
      ResultType: Parent_Type_Enum.ObligationOversightResult,
    })) || []),
    ...(data?.risk_controlled_oversight_result.map((a) => ({
      ...a,
      ParentId: assessmentId,
      ResultType: Parent_Type_Enum.RiskControlledOversightResult,
      ControlType: Risk_Assessment_Result_Control_Type_Enum.Controlled,
    })) || []),
    ...(data?.risk_uncontrolled_oversight_result.map((a) => ({
      ...a,
      ParentId: assessmentId,
      ResultType: Parent_Type_Enum.RiskUncontrolledOversightResult,
      ControlType: Risk_Assessment_Result_Control_Type_Enum.Uncontrolled,
    })) || []),
    ...(data?.control_test_oversight_result.map((a) => ({
      Id: a.Id,
      ParentId: assessmentId,
      Impact: 0,
      Rating: 0,
      OverallEffectiveness: a.OverallEffectiveness,
      ControlType: Risk_Assessment_Result_Control_Type_Enum.Controlled,
      TestDate: a.TestDate,
      parents: [],
      parent: a.parent!,
      files: a.files,
      ancestorContributors: [],
      ResultType: Parent_Type_Enum.ControlTestOversightResult,
    })) || []),
  ];
};
